import { PublicationStatusSchema } from "../solo-cms/publication-status";
import { z } from "zod";

// ====== Response DTO (read) ======

export const TradeTutorialStepDtoSchema = z.object({
  id: z.uuid(),
  stepNumber: z.number().int().min(0),
  title: z.string().nullable().optional(),
  mediaFileId: z.uuid().nullable().optional(),
  mediaUrl: z.string().nullable().optional(),
  descriptionContent: z.string().nullable().optional(),
  descriptionCentered: z.boolean().nullable().optional(),
  publicationStatus: PublicationStatusSchema,
  publishedAt: z.coerce.date().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type TradeTutorialStepDto = z.infer<typeof TradeTutorialStepDtoSchema>;

// ====== Save DTOs (write) ======

const BaseTradeTutorialStepDtoSchema = z.object({
  stepNumber: z.coerce.number().int().min(0),
  title: z.string().nullable().optional(),
  mediaFileId: z.uuid().nullable().optional(),
  descriptionContent: z.string().nullable().optional(),
  descriptionCentered: z.boolean().nullable().optional(),
  publicationStatus: PublicationStatusSchema,
});

export const CreateTradeTutorialStepDtoSchema = BaseTradeTutorialStepDtoSchema;
export type CreateTradeTutorialStepDto = z.infer<typeof CreateTradeTutorialStepDtoSchema>;

export const UpdateTradeTutorialStepDtoSchema = BaseTradeTutorialStepDtoSchema.extend({
  id: z.uuid(),
});
export type UpdateTradeTutorialStepDto = z.infer<typeof UpdateTradeTutorialStepDtoSchema>;

export const SaveTradeTutorialStepDtoSchema = z.union([
  UpdateTradeTutorialStepDtoSchema,
  CreateTradeTutorialStepDtoSchema,
]);
export type SaveTradeTutorialStepDto = z.infer<typeof SaveTradeTutorialStepDtoSchema>;

// ====== Query params ======

export const GetTradeTutorialStepByIdQueryParamsSchema = z.object({
  tradeTutorialStepId: z.uuid(),
});
export type GetTradeTutorialStepByIdQueryParamsDto = z.infer<typeof GetTradeTutorialStepByIdQueryParamsSchema>;

export const GetTradeTutorialStepsByPageQueryParamsSchema = z.object({
  page: z.coerce.number().optional(),
  size: z.coerce.number().optional(),
  search: z.string().optional(),
});
export type GetTradeTutorialStepsByPageQueryParamsDto = z.infer<typeof GetTradeTutorialStepsByPageQueryParamsSchema>;

export const DeleteTradeTutorialStepQueryParamsSchema = z.object({
  tradeTutorialStepId: z.uuid(),
});
export type DeleteTradeTutorialStepQueryParamsDto = z.infer<typeof DeleteTradeTutorialStepQueryParamsSchema>;

// ====== Result schemas ======

export const GetTradeTutorialStepsByPageResultSchema = z.object({
  data: z.array(TradeTutorialStepDtoSchema),
  total: z.number(),
  page: z.number(),
  size: z.number(),
});
export type GetTradeTutorialStepsByPageResultDto = z.infer<typeof GetTradeTutorialStepsByPageResultSchema>;

export const GetPublishedTradeTutorialStepsResultSchema = z.array(TradeTutorialStepDtoSchema);
export type GetPublishedTradeTutorialStepsResultDto = z.infer<typeof GetPublishedTradeTutorialStepsResultSchema>;
